import { API_URL, IP_INFO_URL } from '@src/configs';
import api from './api';

const axios = require('axios');

const getCountry = async () => {
  try {
    const response = await axios({
      method: 'GET',
      url: IP_INFO_URL,
      timeout: 3000,
    });
    return response.data;
  } catch (error) {
    return {};
  }
};

const getAllCountry = async (accessToken) => {
  try {
    const response = await api({
      method: 'GET',
      url: `${API_URL}/api/v1/countries`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
    return response?.result;
  } catch (error) {
    return [];
  }
};

export { getCountry, getAllCountry };
